export const WEEK = '/week';
export const AGENDA = '/agenda';
export const ROOT = '/';
